import axios from 'axios'
import qs from "qs";
import router from "@/router"
import config from "@/config/config.json";
import {i18n} from "@/modules/i18n/i18n";
import * as syncApi from "@/modules/api/sync";
import {clearReaderData , clearHomeData} from  "@/modules/stateControl";
import {apiErrorHandler} from "@/modules/api/error";

//TODO: error handling!
const authenticate = async (username, password) => {

        let accessToken, userInfo;
        let loginResult = await auth(username, password);

        if (loginResult.data.error) {
            if (loginResult.data.error === "invalid_request") {
                throw new Error("error_msg_login_invalid_account");
            } else if (loginResult.data.error === "invalid_grant") {
                throw new Error("error_msg_login_no_ebook_grant");
            } else {
                throw new Error("error_msg_generic");
            }
        }

        accessToken = loginResult.data.access_token.access_token;
        userInfo = loginResult.data.userinfo;
        let userPermission = await checkUserPermission(accessToken);
        let isMultipleLogin = checkIsMultipleLogin(userPermission)
        let bookList = await getBooks(accessToken);

        storeUserData({
            accessToken: accessToken,
            userInfo: {
                membercode: userInfo.membercode,
                name: {
                    en: userInfo.nameen,
                    zh: userInfo.namezh
                },
                avatar: userInfo.profile,
                role: userInfo.role,
                isMultipleLogin: isMultipleLogin
            },
            ebooklist: bookList.data.ebooklist
        });

        return bookList;

}

/** Normal password grant login **/
const auth = async (username, password) => {
    return await axios.post(`/${process.env.VUE_APP_SERVLET_PATH}/proxy/login/`,
        qs.stringify({
            account: username,
            password: password
        }),
        {
            withCredentials: true,
        });

}

/** SSO Login **/

const ssoLogin = async (accessToken) => {

    return await axios.post(`/${process.env.VUE_APP_SERVLET_PATH}/proxy/ssoLogin/`,
        qs.stringify({
            access_token:accessToken
        }),
        {
            withCredentials: true,
        }
    );


}

const handleSSO = async (accessToken) => {

    let userInfo;
    const ssoResult = await ssoLogin(accessToken);

    if (!ssoResult.data.error) {
        userInfo = ssoResult.data.userinfo;
        let returnedToken = ssoResult.data.access_token.access_token;
        let userPermission = await checkUserPermission(returnedToken);
        let isMultipleLogin = checkIsMultipleLogin(userPermission)
        let bookList = await getBooks(returnedToken);
        const licensingUnit = await getLicensingUnit(returnedToken);

        storeUserData({
            accessToken: returnedToken,
            isSSO:true,
            userInfo: {
                membercode: userInfo.membercode,
                name: {
                    en: userInfo.nameen,
                    zh: userInfo.namezh
                },
                avatar: userInfo.profile,
                role: userInfo.role,
                isMultipleLogin: isMultipleLogin
            },
            ebooklist: bookList.data.ebooklist,
            licensingUnit:licensingUnit
        });

        return bookList;
    } else {
        throw new Error("sso_error")
    }

}

const checkUserPermission = async (accessToken) => {
    return await axios.post(`${process.env.VUE_APP_URI_MPMS_API}auth/user_permission`,
        qs.stringify({

        }),
        {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        },
        {
            withCredentials: true
        }
    );

}

/**
 * For getting other platform access details on SSO login
 */
const getLicensingUnit = (accessToken)=> {
    return axios.post(`${process.env.VUE_APP_URI_MPMS_API}product/getlicensingunit`,
        qs.stringify({

        }),
        {
            headers: {
                Authorization: 'Bearer ' +  accessToken
            }
        });
}

const checkIsMultipleLogin = (permission)=> {

    let isMultipleLogin = false;

    for (let item of permission.data) {

        //user is allowed multiple auth if groupid "MPSAGPATTR" exists and concurrent auth > 0
        if (item.groupid === config.login.multipleLoginGroupId) {

            if (item.abbr !== undefined) {
                //the attribute "concurrent_login" of the json data to check for multiple auth or not
                let conCurrentInfo = item.abbr.filter(el=>{
                    return el.attribute === config.login.multipleLoginAttribute
                });

                if (conCurrentInfo.length === 1) {
                    console.log("conCurrentInfo.value!!! " + conCurrentInfo[0].value)
                    isMultipleLogin = parseInt(conCurrentInfo[0].value) > 0;
                    break;
                }
            }
        }
    }

    console.log("isMultipleLogin?");
    console.log(isMultipleLogin)

    return isMultipleLogin;

}

const isTeacher = ()=> {
    return (localStorage.role && localStorage.role === "TCHR");
}

const isStudent = ()=> {
    return (localStorage.role && localStorage.role === "SDNT");
}

const getBooks = (accessToken)=> {

    return axios.post(`${process.env.VUE_APP_URI_MPMS_API}ebook/getbooks`,
        qs.stringify({}),
        {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        }
    );
}

/**
 * Since authenticate is processed at backend and the sessions are held in the server,
 * use localStorage to store userdata in frontend side
 */
const storeUserData = (userData)=>{

    localStorage.clear();
    localStorage.accessToken = userData.accessToken;
    localStorage.membercode = userData.userInfo.membercode;
    localStorage.name = JSON.stringify(userData.userInfo.name);
    localStorage.avatar = userData.userInfo.avatar;
    localStorage.role = userData.userInfo.role;
    localStorage.ebooklist = JSON.stringify(userData.ebooklist);
    localStorage.licensingUnit = JSON.stringify(userData.licensingUnit);

    if (userData.isSSO) {
        localStorage.isSSO = true;
    }

    console.log("localStorage:");
    console.log(localStorage);

}


const checkToken = async (accessToken, redirectedFrom)=> {

    if (!accessToken) {
        forceLogout(redirectedFrom);
        return;
    }

    const result = await axios.post(`${process.env.VUE_APP_URI_MPMS_API}auth/checktoken`,
        qs.stringify({

        }),
        {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        },
        {
            withCredentials: true
        }
    );


    apiErrorHandler(result, redirectedFrom);
    return result;
}

/**
 * Logout action triggered actively by user
 * @returns {Promise<*>}
 */
const logout = async()=> {
    let result =  await axios.post(`/${process.env.VUE_APP_SERVLET_PATH}/proxy/logout`,
        qs.stringify({
            access_token:getSSOOrNormalToken()
        }),
        {
            //withCredentials: true
        }
    );
    clearReaderData();
    clearHomeData();
    clearLocalStorage();
    return result;
}

/**
 * Called if token is invalid
 * isNotRouteChange indicates whether the token is checked when route is not changing.
 */
const forceLogout = (redirectedFrom)=>{
   alert(i18n.t("info_msg_login_expired"))
    clearReaderData();
    clearHomeData();
    clearLocalStorage();

    if (redirectedFrom) {

        if (redirectedFrom !== "/") {
            router.push({
                path: '/login',
                query: {
                    redirect: redirectedFrom,
                    loggedOut:1
                },
            });
        } else {
            router.push({
                path: '/login',
                loggedOut:1
            });
        }

    } else {
        router.push({path:"login", query:{loggedOut:1}});
    }
}

const clearLocalStorage = ()=>{
    localStorage.clear();
}

/**
 * Note that if sso, the last 2 characters ("==") of the access_token has to be trimmed...
 * @returns {*}
 */
const getSSOOrNormalToken = ()=>{
    return ( localStorage.isSSO) ?  localStorage.accessToken.slice(0, -2): localStorage.accessToken;
}

export
{
    authenticate,
    handleSSO,
    checkToken,
    logout,
    clearLocalStorage,
    forceLogout,
    isTeacher,
    isStudent,
    getSSOOrNormalToken
}